<template>
  <div class="featured-collection critical-component-clear">
    <content-carousel
      :cards="products"
      card-type="product"
      carousel-pagination
      :cta-text="content.ctaText"
      :cta-url="content.ctaUrl"
      :subtitle="content.subtitle"
      :title="content.title"
    />
  </div>
</template>

<script>

/**
 * Vue: Featured collection (featured-collection)
 * -----------------------------------------------------------------------------
 * A section to display product cards.
 * - Component settings: section / dynamic / async / scroll
 *
 * @param {Object} content - Section's text content.
 * @param {String} [content.title]- Title text.
 * @param {String} [content.subtitle]- Subtitle text.
 * @param {String} [content.ctaText]- Cta text.
 * @param {String} [content.ctaUrl]- Cta url.
 * @param {Array} products - Array of products
 *
 */
import ContentCarousel from '~async/content-carousel/content-carousel.vue'

export default {
  name: 'FeaturedCollection',
  components: { ContentCarousel },

  props: {
    content: {
      type: Object,
      default: () => ({
        ctaText: '',
        ctaUrl: '',
        subtitle: '',
        title: '',
      }),
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
@import './featured-collection';
</style>
